import styled from '@emotion/styled'
import { Dispatch, FC, SetStateAction } from 'react'

export enum TicketDetailTab {
  Details = 'Details',
  Updates = 'Activity',
}

interface TicketDetailTabsProps {
  selectedTab: TicketDetailTab
  setSelectedTab: Dispatch<SetStateAction<TicketDetailTab>>
}
export const TicketDetailTabs: FC<TicketDetailTabsProps> = (props) => {
  return (
    <div className="mb-4 flex flex-row border-b border-secondary md:hidden">
      {Object.values(TicketDetailTab).map((tab, i) => (
        <Tab key={i} tabName={tab} {...props} />
      ))}
    </div>
  )
}

interface TabProps {
  selectedTab: TicketDetailTabsProps['selectedTab']
  setSelectedTab: TicketDetailTabsProps['setSelectedTab']
  tabName: TicketDetailTab
}
const Tab = ({ tabName, selectedTab, setSelectedTab }: TabProps) => {
  const handleClick = () => setSelectedTab(tabName)
  const isSelected = tabName === selectedTab
  return (
    <StyledButton isSelected={isSelected} onClick={handleClick}>
      {tabName}
    </StyledButton>
  )
}

const StyledButton = styled.button<{ isSelected: boolean }>`
  margin-left: 0;
  margin-right: 2rem;
  border-bottom-width: 2px;
  padding-bottom: 0.25rem;
  font-weight: 700;
  border-color: transparent;

  &:first-of-type {
    margin-left: 1.5rem;
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    border-color: #08786C;
    color: #08786C;
  `}
`
